import JwtParser from 'jsonwebtoken';
import logger from '../logger';
import makeAPIRequest from './make-api-request';

const refreshToken = (token) =>
  new Promise((resolve, reject) => {
    makeAPIRequest('v2/auth/jwt/refresh', {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        if (response.status !== 201) {
          throw new Error(`Refresh failed with status code: ${response.status}`);
        } else {
          return response.json();
        }
      })
      .then((responseData) => {
        const { token: refreshedToken } = responseData;
        resolve(refreshedToken);
      })
      .catch((error) => {
        reject(error);
      });
  });

const checkToken = (request) =>
  new Promise((resolve) => {
    if (!request.session || !request.session.jwt) {
      logger.info('checkToken: Session has no token to check');
      resolve(null);
    } else {
      try {
        const { jwt: token } = request.session;
        const decoded = JwtParser.decode(token);
        const { exp } = decoded;
        if (Date.now() / 1000 < exp) {
          // valid in date token
          logger.info('checkToken: Token is valid, returning it');
          resolve(token);
        } else {
          // Expired token, attempt refresh.
          logger.info('checkToken: Token has expired, attempting to refresh');
          refreshToken(token)
            .then((refreshedToken) => {
              request.session.jwt = refreshedToken;
              resolve(refreshedToken);
            })
            .catch((error) => {
              logger.error('checkToken: error refreshing token', { error });
              delete request.session.jwt;
              resolve(null);
            });
        }
      } catch (error) {
        logger.error('checkToken: error decoding token', { error });
        delete request.session.jwt;
        resolve(null);
      }
    }
  });

export default checkToken;
